module.exports = __webpack_public_path__ + "static/media/anne-laure-conversation.ce0b1ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anne-laure-conversation.png
// module id = 2497
// module chunks = 0